import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  action: "insert",

  name: null,
  type: null,
  product: null,
  MSA: null,

  contrNo: null,
  sprName: null,
  quotNo: null,

  WODate: null,
  unitCost: null,
  contrPeriod: null,
  startDate: null,
  endDate: null,
  remark: null,

  updateFields: [],
};

export const vendorContractSlice = createSlice({
  name: "vendorContract",
  initialState,
  reducers: {
    init: (state, action) => {
      // console.debug("[init]");

      return {
        ...initialState,
      };
    },

    updateAll: (state, action) => {
      return {
        ...action.payload,
        updateFields: [],
      };
    },

    updateAction: (state, action) => {
      return {
        ...state,
        action: action.payload.action,
      };
    },

    updateName: (state, action) => {
      return {
        ...state,
        name: action.payload.name,
        updateFields: [...state.updateFields, "name"],
      };
    },

    updateType: (state, action) => {
      return {
        ...state,
        type: action.payload.type,
        updateFields: [...state.updateFields, "type"],
      };
    },

    updateProduct: (state, action) => {
      return {
        ...state,
        product: action.payload.product,
        updateFields: [...state.updateFields, "product"],
      };
    },

    updateMSA: (state, action) => {
      return {
        ...state,
        MSA: action.payload.MSA,
        updateFields: [...state.updateFields, "MSA"],
      };
    },

    updateContrNo: (state, action) => {
      return {
        ...state,
        contrNo: action.payload.contrNo,
        updateFields: [...state.updateFields, "contrNo"],
      };
    },

    updateBasicInfo: (state, action) => {
      // console.debug("[updateBasicInfo]");

      return {
        ...state,
        contrNo: action.payload.contrNo,
        sprName: action.payload.sprName,
        quotNo: action.payload.quotNo,
        updateFields: [...state.updateFields, "contrNo"],
      };
    },

    updateWODate: (state, action) => {
      return {
        ...state,
        WODate: action.payload.WODate,
        updateFields: [...state.updateFields, "WODate"],
      };
    },

    updateUnitCost: (state, action) => {
      return {
        ...state,
        unitCost: action.payload.unitCost,
        updateFields: [...state.updateFields, "unitCost"],
      };
    },

    updateContrPeriod: (state, action) => {
      return {
        ...state,
        contrPeriod: action.payload.contrPeriod,
        updateFields: [...state.updateFields, "contrPeriod"],
      };
    },

    updateStartDate: (state, action) => {
      return {
        ...state,
        startDate: action.payload.startDate,
        updateFields: [...state.updateFields, "startDate"],
      };
    },

    updateEndDate: (state, action) => {
      return {
        ...state,
        endDate: action.payload.endDate,
        updateFields: [...state.updateFields, "endDate"],
      };
    },

    updateRemark: (state, action) => {
      return {
        ...state,
        remark: action.payload.remark,
        updateFields: [...state.updateFields, "remark"],
      };
    },
  },
});

export const {
  init,
  updateAll,
  updateAction,
  updateName,
  updateType,
  updateProduct,
  updateMSA,
  updateContrNo,
  updateBasicInfo,
  updateWODate,
  updateUnitCost,
  updateContrPeriod,
  updateStartDate,
  updateEndDate,
  updateRemark,
} = vendorContractSlice.actions;

export default vendorContractSlice.reducer;
